import axios from "../utils/axios.wrapper";

export const getMenuPlans = async (shopId, from, to) => {
  const { data } = await axios.get(
    `/MenuPlan/shop/${shopId}?from=${from}&to=${to}`,
  );
  return data.items || data;
};

export const getAllMenuPlans = async () => {
  const { data } = await axios.get(`/MenuPlan`);
  return data.items || data;
};

export const createMenuPlan = async (plan) => {
  const { data } = await axios.post("/MenuPlan/create", plan);
  return data.items || data; // maintenant un tableau
};

export const deleteMenuPlan = async (id) => {
  const { data } = await axios.delete(`/MenuPlan/${id}`);
  return data;
};

export const menuPlanService = {
  getMenuPlans,
  getAllMenuPlans,
  createMenuPlan,
  deleteMenuPlan,
};
